const $$splitComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app/user-management/invitations.tsx?tsr-split=component');
const $$splitErrorComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app/user-management/invitations.tsx?tsr-split=errorComponent');
import { lazyRouteComponent } from '@tanstack/react-router';
import { requireCapabilities } from '@/features/authentication/lib/routeGuards';
import { AdminInvitationsSkeleton } from '@/features/invitations/components/AdminInvitationsSkeleton';
import { adminInvitationSearchSchema } from '@/features/invitations/lib/adminInvitationSearch';
import { adminInvitationsQuery } from '@/features/invitations/services/adminInvitations';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_authenticated/_app/user-management/invitations')({
  validateSearch: adminInvitationSearchSchema,
  beforeLoad: requireCapabilities(has => has('organization-members.list') && has('organizations.list')),
  loaderDeps: ({
    search
  }) => ({
    organizationId: search.organizationId,
    q: search.q,
    status: search.status
  }),
  loader: async ({
    context,
    deps
  }) => {
    const query = adminInvitationsQuery(deps);
    const hasCachedData = context.queryClient.getQueryState(query.queryKey)?.data !== undefined;
    if (!hasCachedData) {
      await context.queryClient.ensureQueryData(query);
    }
  },
  pendingComponent: AdminInvitationsSkeleton,
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent'),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});